// Analytics TikTok (2026-10-12): statistik akun (user.info.stats) & video terbaru (video.list).
// Selama scope itu belum disetujui TikTok, tiap akun berstatus 'scope_kurang' → tampil keterangan dan
// tombol "Lihat contoh tampilan" berisi DATA CONTOH berlabel jelas (bahan video review TikTok).
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';

const API = 'https://api.sm-media.id';
const fmt = n => Number(n || 0).toLocaleString('id-ID');

const CONTOH = {
  contoh: true,
  totals: { followers: 12840, likes_total: 356200, video_count: 148, recent_views: 482300 },
  accounts: [{
    id: 'contoh', username: 'akun.contoh', display_name: 'Akun Contoh', avatar_url: null, status: 'ok',
    followers: 12840, likes_total: 356200, video_count: 148,
    videos: [
      { id: 'c1', title: 'Contoh video 1 — cuplikan lagu', created_at: '2026-10-10T10:00:00Z', views: 182400, likes: 15200, comments: 410, shares: 960 },
      { id: 'c2', title: 'Contoh video 2 — cuplikan lagu', created_at: '2026-10-09T12:00:00Z', views: 97300, likes: 8100, comments: 205, shares: 430 },
      { id: 'c3', title: 'Contoh video 3 — cuplikan lagu', created_at: '2026-10-08T09:00:00Z', views: 64100, likes: 4900, comments: 133, shares: 210 },
      { id: 'c4', title: 'Contoh video 4 — cuplikan lagu', created_at: '2026-10-07T15:00:00Z', views: 138500, likes: 11700, comments: 362, shares: 805 },
    ],
  }],
};

function Tile({ icon, label, value }) {
  return (
    <div style={{ background: colors.bgCardMuted, borderRadius: radius.md, padding: '12px 10px', textAlign: 'center' }}>
      <i className={`ti ${icon}`} style={{ fontSize: 18, color: colors.textSecondary, display: 'block', marginBottom: 4 }}></i>
      <div style={{ fontSize: 18, fontWeight: 700, color: colors.textPrimary }}>{fmt(value)}</div>
      <div style={{ fontSize: 11, color: colors.textSecondary }}>{label}</div>
    </div>
  );
}

function Akun({ a }) {
  const [buka, setBuka] = useState(false);
  return (
    <div style={{ borderTop: `1px solid ${colors.border}` }}>
      <div onClick={() => a.status === 'ok' && setBuka(v => !v)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px', flexWrap: 'wrap', cursor: a.status === 'ok' ? 'pointer' : 'default' }}>
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: colors.bgCardMuted, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: colors.textSecondary, flexShrink: 0 }}>
          {a.avatar_url ? <img src={a.avatar_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (a.display_name || 'T').charAt(0)}
        </div>
        <div style={{ flex: '1 1 140px', minWidth: 0 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary }}>{a.display_name || a.username}</div>
          <div style={{ fontSize: 11, color: colors.textSecondary }}>@{a.username}</div>
        </div>
        {a.status === 'ok' ? (
          <div style={{ display: 'flex', gap: 14, fontSize: 12, color: colors.textSecondary, flexWrap: 'wrap' }}>
            <span><i className="ti ti-users" style={{ fontSize: 13, marginRight: 3 }}></i>{fmt(a.followers)}</span>
            <span><i className="ti ti-heart" style={{ fontSize: 13, marginRight: 3 }}></i>{fmt(a.likes_total)}</span>
            <span><i className="ti ti-video" style={{ fontSize: 13, marginRight: 3 }}></i>{fmt(a.video_count)} video</span>
            <i className={`ti ${buka ? 'ti-chevron-up' : 'ti-chevron-down'}`} style={{ fontSize: 14 }}></i>
          </div>
        ) : (
          <span style={{ fontSize: 11.5, color: a.status === 'gagal' || a.status === 'perlu_reconnect' ? colors.danger : colors.warning }}>
            {a.status === 'scope_kurang' ? 'Menunggu izin analytics dari TikTok' : a.status === 'perlu_reconnect' ? 'Perlu dihubungkan ulang' : `Gagal dimuat (${a.error || 'error'})`}
          </span>
        )}
      </div>
      {buka && a.status === 'ok' && (
        <div style={{ padding: '0 16px 14px' }}>
          {(a.videos || []).length === 0 ? (
            <div style={{ fontSize: 12, color: colors.textSecondary }}>Belum ada video.</div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, minWidth: 460 }}>
                <thead>
                  <tr style={{ color: colors.textSecondary, textAlign: 'right' }}>
                    <th style={{ textAlign: 'left', padding: '6px 4px', fontWeight: 600 }}>Video terbaru</th>
                    <th style={{ padding: '6px 4px', fontWeight: 600 }}>Views</th>
                    <th style={{ padding: '6px 4px', fontWeight: 600 }}>Like</th>
                    <th style={{ padding: '6px 4px', fontWeight: 600 }}>Komentar</th>
                    <th style={{ padding: '6px 4px', fontWeight: 600 }}>Share</th>
                  </tr>
                </thead>
                <tbody>
                  {a.videos.map(v => (
                    <tr key={v.id} style={{ borderTop: `1px solid ${colors.border}`, textAlign: 'right', color: colors.textPrimary }}>
                      <td style={{ textAlign: 'left', padding: '7px 4px', maxWidth: 260 }}>
                        {v.url ? <a href={v.url} target="_blank" rel="noreferrer" style={{ color: colors.accentText }}>{v.title || '(tanpa judul)'}</a> : (v.title || '(tanpa judul)')}
                        {v.created_at && <div style={{ fontSize: 10.5, color: colors.textSecondary }}>{new Date(v.created_at).toLocaleDateString('id-ID')}</div>}
                      </td>
                      <td style={{ padding: '7px 4px', fontVariantNumeric: 'tabular-nums' }}>{fmt(v.views)}</td>
                      <td style={{ padding: '7px 4px', fontVariantNumeric: 'tabular-nums' }}>{fmt(v.likes)}</td>
                      <td style={{ padding: '7px 4px', fontVariantNumeric: 'tabular-nums' }}>{fmt(v.comments)}</td>
                      <td style={{ padding: '7px 4px', fontVariantNumeric: 'tabular-nums' }}>{fmt(v.shares)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function TiktokAnalytics({ refreshKey }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [contoh, setContoh] = useState(false);
  useEffect(() => {
    let hidup = true;
    axios.get(`${API}/api/analytics/tiktok${refreshKey ? '?refresh=1' : ''}`)
      .then(r => { if (hidup) setData(r.data); })
      .catch(e => { if (hidup) setErr(e.response?.data?.error || 'Gagal memuat analytics TikTok'); });
    return () => { hidup = false; };
  }, [refreshKey]);

  const tampil = contoh ? CONTOH : data;
  const accounts = (tampil && tampil.accounts) || [];
  const butuhIzin = data && data.accounts.length > 0 && data.accounts.every(a => a.status === 'scope_kurang');

  return (
    <div style={{ background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, marginBottom: 16, overflow: 'hidden' }}>
      <div style={{ padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <i className="ti ti-brand-tiktok" style={{ fontSize: 16, color: colors.textPrimary }}></i>
        <span style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary, flex: 1 }}>Performa TikTok</span>
        {(butuhIzin || contoh) && (
          <button type="button" onClick={() => setContoh(v => !v)}
            style={{ fontSize: 12, fontWeight: 600, padding: '6px 12px', borderRadius: 999, cursor: 'pointer', border: `1px solid ${colors.border}`, background: contoh ? colors.accentMuted : colors.bgCard, color: contoh ? colors.accentText : colors.textPrimary }}>
            {contoh ? 'Tutup contoh tampilan' : 'Lihat contoh tampilan'}
          </button>
        )}
      </div>
      {contoh && (
        <div style={{ margin: '0 16px 12px', padding: '8px 12px', borderRadius: radius.md, background: colors.warningMuted, color: colors.textPrimary, fontSize: 12 }}>
          <b>DATA CONTOH</b> — bukan data akun sungguhan. Ini pratinjau tampilan setelah izin analytics TikTok (video.list, user.info.stats) disetujui.
        </div>
      )}
      {!contoh && err && <div style={{ padding: '0 16px 14px', fontSize: 12, color: colors.danger }}>{err}</div>}
      {!contoh && !data && !err && <div style={{ padding: '0 16px 14px', fontSize: 12, color: colors.textSecondary }}>Memuat…</div>}
      {!contoh && data && data.accounts.length === 0 && (
        <div style={{ padding: '0 16px 14px', fontSize: 12, color: colors.textSecondary }}>Belum ada akun TikTok terhubung.</div>
      )}
      {!contoh && butuhIzin && (
        <div style={{ margin: '0 16px 12px', padding: '8px 12px', borderRadius: radius.md, background: colors.bgCardMuted, fontSize: 12, color: colors.textSecondary, lineHeight: 1.5 }}>
          Statistik akun & video TikTok membutuhkan izin tambahan (<b>video.list</b>, <b>user.info.stats</b>) yang sedang diajukan ke TikTok.
          Setelah disetujui, hubungkan ulang akun TikTok sekali untuk mengaktifkan bagian ini.
        </div>
      )}
      {tampil && tampil.accounts.some(a => a.status === 'ok') && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: 8, padding: '0 16px 14px' }}>
          <Tile icon="ti-users" label="Followers" value={tampil.totals.followers} />
          <Tile icon="ti-heart" label="Total Like" value={tampil.totals.likes_total} />
          <Tile icon="ti-video" label="Jumlah Video" value={tampil.totals.video_count} />
          <Tile icon="ti-eye" label="Views video terbaru" value={tampil.totals.recent_views} />
        </div>
      )}
      {accounts.map(a => <Akun key={a.id} a={a} />)}
    </div>
  );
}
